import { Button, Form, Input, Modal, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { MainContext } from "src/context";
import {
  GetUniversities,
  SignInTeacherConfig,
} from "src/service/api/open";
import { LoginTypes, UniversityTypes } from "src/static/interface";
import { rules } from "src/static/rules";
import { catchFunc, handleLoginFunc } from "src/utils";
import { USER_POSITION } from "src/static/const";
import { useTranslation } from "src/i18n/context";

interface LoginProps {
  showButtons?: boolean;
  modalOnly?: boolean;
}

function Login({ showButtons = true, modalOnly = false }: LoginProps) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const { loginOpen, setLoginOpen } = useContext(MainContext);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [universities, setUniversities] = useState<UniversityTypes[]>([]);

  const openModal = () => {
    setLoginOpen?.(true);
  };
  const closeModal = () => {
    setLoginOpen?.(false);
    form.resetFields();
  };
  const handleSubmit = (val: LoginTypes) => {
    setLoading(true);
    // Faqat o'qituvchilar uchun login
    SignInTeacherConfig(val)
      .then((res) => {
        localStorage.setItem(USER_POSITION, "TEACHER");
        handleLoginFunc(res.data.object);
      })
      .catch((err) => catchFunc(err))
      .finally(() => setLoading(false));
  };
  const getFunc = () => {
    if (universities.length === 0)
      GetUniversities().then((res) => {
        setUniversities(res.data);
      });
  };
  useEffect(() => {
    getFunc();
  }, []);

  const handleSelect = (code: number) => {
    form.setFieldsValue({ login: code });
  };

  // Faqat modal kerak bo'lsa
  if (modalOnly) {
    return (
      <Modal
        open={loginOpen}
        title=""
        footer=""
        width={500}
        onCancel={closeModal}
        className="login-modal"
      >
        <h2 className="login-main-title">{t("auth.forTeachers")}</h2>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            name="universityCode"
            label={t("auth.university")}
            rules={[rules.university]}
          >
            <Select
              size="large"
              allowClear
              placeholder={rules.university.message}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onChange={handleSelect}
            >
              {universities.map((item) => (
                <Option key={item.id} value={item.code}>
                  {item.code + " - " + item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={t("auth.hemisLogin")}
            name="login"
            rules={[rules.hemis_login]}
          >
            <Input size="large" placeholder={rules.hemis_login.message} />
          </Form.Item>

          <Form.Item
            label={t("auth.hemisPassword")}
            name="password"
            rules={[rules.hemis_password]}
          >
            <Input.Password
              placeholder={rules.hemis_password.message}
              type="text"
              size="large"
            />
          </Form.Item>

          <Button
            type="primary"
            size="large"
            className="full-width login-main-button"
            htmlType="submit"
            loading={loading}
          >
            {t("auth.login")}
          </Button>

          <div className="login-main-or">
            <span></span> {t("common.or")} <span></span>
          </div>

          <a href="https://survey.hemis.uz/api/auth/oneIdTeacher">
            <Button
              type="primary"
              size="large"
              className="login-main-button-oneid"
            >
              {t("auth.oneId")}
            </Button>
          </a>
        </Form>
      </Modal>
    );
  }

  return (
    <>
      {showButtons && (
        <div className="login-buttons-container" style={{ display: "flex", gap: 8 }}>
          {/* <button
            className="kirish student-btn"
            onClick={() => window.open("https://my.hemis.uz", "_blank")}
          >
            {t("auth.student")}
          </button> */}
          <button className="kirish teacher-btn" onClick={openModal}>
            {t("auth.teacher")}
          </button>
        </div>
      )}

      {/* Login modal */}
      <Modal
        open={loginOpen}
        title=""
        footer=""
        width={500}
        onCancel={closeModal}
        className="login-modal"
      >
        <h2 className="login-main-title">{t("auth.forTeachers")}</h2>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item
            name="universityCode"
            label={t("auth.university")}
            rules={[rules.university]}
          >
            <Select
              size="large"
              allowClear
              placeholder={rules.university.message}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option: any) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onChange={handleSelect}
            >
              {universities.map((item) => (
                <Option key={item.id} value={item.code}>
                  {item.code + " - " + item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label={t("auth.hemisLogin")}
            name="login"
            rules={[rules.hemis_login]}
          >
            <Input size="large" placeholder={rules.hemis_login.message} />
          </Form.Item>

          <Form.Item
            label={t("auth.hemisPassword")}
            name="password"
            rules={[rules.hemis_password]}
          >
            <Input.Password
              placeholder={rules.hemis_password.message}
              type="text"
              size="large"
            />
          </Form.Item>

          <Button
            type="primary"
            size="large"
            className="full-width login-main-button"
            htmlType="submit"
            loading={loading}
          >
            {t("auth.login")}
          </Button>

          <div className="login-main-or">
            <span></span> {t("common.or")} <span></span>
          </div>

          <a href="https://survey.hemis.uz/api/auth/oneIdTeacher">
            <Button
              type="primary"
              size="large"
              className="login-main-button-oneid"
            >
              {t("auth.oneId")}
            </Button>
          </a>
        </Form>
      </Modal>
    </>
  );
}

export default Login;
